module.exports = __webpack_public_path__ + "static/kazuha-banner-6d40c859546f3c618fd36b94b456d05f.png";